import React, { useEffect, useState } from "react";
import { postData } from "../../../services/api";
import PricingItemsMonthly from "./PricingItems/PricingItemsMonthly";
import PricingItemsYear from "./PricingItems/PricingItemsYear";

const PriceingPlans = () => {
  const [activeTab, setActiveTab] = useState("Monthly");
  const [plans, setPlans] = useState([]);
  const tabs = ["Monthly", "Annual"];

  useEffect(() => {
    const loadPlans = async () => {
      try {
        const result = await postData("plans/list", {
          limit: 4,
          offset: 0,
          sortQuery: { ordering: 1 },
          isView: 1,
        });
        if (result.data) {
          //const rowLen = result?.data?.length;
          const bgColors = ["bg-[#FFF6F6]", "bg-[#F0F2FF]", "bg-[#E7FAFC]"];
          const data = result?.data?.map((it, ind) => ({
            ...it,
            bgColor: bgColors[ind % bgColors.length],
          }));

          setPlans(data);
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    loadPlans();
  }, []);

  // const pricingItemsMonthly = [
  //   {
  //     title: "Essential Plan",
  //     price: 275,
  //     descriptionTwo:
  //       "Our tool facilitates enhanced governance and strengthens organizational resilience.",
  //     items: [
  //       "1 Admin and User Training Sessions",
  //       "1 Personal Consultation For Creating Succession Plan",
  //       "10 Succession Plans Per Year",
  //     ],
  //     bgColor: "bg-[#FFF6F6]",
  //     textColor: "text-purple-700",
  //   },
  //   {
  //     title: "Professional Plan",
  //     price: 525,
  //     items: [
  //       "2 Admin and User Training Sessions",
  //       "2 Personal Consultation For Creating Succession Plan",
  //       "25 Succession Plans Per Year",
  //     ],
  //     descriptionTwo:
  //       "Our platform goes beyond simple categorization, offering a nuanced approach to employee evaluations to mitagate bias and customization to adapt to your organization's evolving needs.",
  //     bgColor: "bg-[#F0F2FF]",
  //     textColor: "text-red-700",
  //   },
  //   {
  //     title: "Enterprise Plan",
  //     price: 925,
  //     items: [
  //       "3 Admin and User Training Sessions",
  //       "3 Personal Consultation For Creating Succession Plan",
  //       "Unlimited Succession Plans Per Year",
  //     ],
  //     descriptionTwo:
  //       "Use the audits to improve communication and understanding and align your Executive Team with organizational goals.",
  //     bgColor: "bg-[#E7FAFC]",
  //     textColor: "text-blue-700",
  //   },
  // ];

  // const pricingItemsAnnual = [
  //   {
  //     title: "Essential Plan",
  //     price: 2.995,
  //     items: [
  //       "1 Admin and User Training Sessions",
  //       "1 Personal Consultation For Creating Succession Plan",
  //       "10 Succession Plans Per Year",
  //     ],
  //     bgColor: "bg-[#FFF6F6]",
  //     textColor: "text-purple-700",
  //     discount: 9,
  //   },
  //   {
  //     title: "Professional Plan",
  //     price: 5.595,
  //     items: [
  //       "2 Admin and User Training Sessions",
  //       "2 Personal Consultation For Creating Succession Plan",
  //       "25 Succession Plans Per Year",
  //     ],
  //     bgColor: "bg-[#F0F2FF]",
  //     textColor: "text-red-700",
  //     discount: 11,
  //   },
  //   {
  //     title: "Enterprise Plan",
  //     price: 9.995,
  //     items: [
  //       "3 Admin and User Training Sessions",
  //       "3 Personal Consultation For Creating Succession Plan",
  //       "Unlimited Succession Plans Per Year",
  //     ],
  //     bgColor: "bg-[#E7FAFC]",
  //     textColor: "text-blue-700",
  //     discount: 10,
  //   },
  // ];

 
  return (
    <section className="w-full my-12 md:my-28" id="pricingPlan-section">
      <div className="w-full">
        <div className="space-y-8 px-5">
          <div className="font-normal  text-black font-IBM text-[48px] text-center w-full">
            <span className="italic">Pricing & Plans</span>
          </div>
          <div className="text-center font-medium text-black font-Outfit text-[16px] max-w-[545px] mx-auto">
            Enhance your succession strategy with our powerful evaluation tools:
            Board Strength, 9Box Now, and Executive Audit 360. These integrated
            tools provide data-driven insights that support informed
            decision-making, reduc- ing subjectivity and enhancing the overall
            effectiveness of your succession planning process.
          </div>
        </div>
      </div>

      <div className="w-full flex justify-center items-center mt-8">
        <div className="w-[258px] h-[52px] flex items-center bg-[#DCECEC] rounded-full gap-1">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`flex-1 h-full text-center rounded-full transition-all relative ${
                activeTab === tab ? "bg-black text-white" : "text-black"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-5 w-full">
        {activeTab === "Monthly" && (
          <PricingItemsMonthly
            pricingItems={plans}
            activeTab={activeTab === "Monthly" ? "month" : ""}
          />
        )}
        {activeTab === "Annual" && (
          <PricingItemsYear
            pricingItems={plans}
            activeTab={activeTab === "Annual" ? "year" : ""}
          />
        )}
      </div>
      <div className="w-full flex justify-center items-center mt-8 px-32">
        <div class="flex items-center justify-center md:justify-end text-[20px] font-Outfit font-normal w-full">
          *Annual contract required
        </div>
      </div>
    </section>
  );
};

export default PriceingPlans;
